import axiosInstances from '@/../../coreui/server/axiosInstances'

// Sleep function to enforce rate limits
async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

async function mailChimpSync(action) {
    let obj = {}
    obj["action"] = action
    let waiting = true
    let res = await axiosInstances.apiServer.post('/dt/v1/temp_mailchimp', obj)
    let id = res.data.id
    while (waiting) {
        console.log(`Waiting`)
        try {
            let check = await axiosInstances.apiServer.get(`/dt/v1/temp_mailchimp/${id}`)
            if (check.status === 200) await sleep(2000)
        }
        catch {
            waiting = false
        }
    }
    console.log(`Finished Waiting`)
}

async function getTemplateList() {
    let list = await axiosInstances.apiServer.get(`/dt/v1/crm_template`)
    return list.data
}

async function getStateList() {
    let list = await axiosInstances.loginServer.get(`/dt/v1/set_usstate`)
    return list.data
}

async function getCampaignList() {
    let list = await axiosInstances.apiServer.get(`/dt/v1/crm_campaign`)
    return list.data
}

async function runQuery(query) {
    query.push({ "$count": "email_count" })
    console.log(`Query = ${query}`)
    let queryResult = await axiosInstances.apiServer.post(`/misc/dbops?c=crm_prospect&op=pipe`, JSON.stringify(query))
    if (queryResult.data === null) return 0
    else {
        let email_count = queryResult.data[0]["email_count"]
        return email_count
    }
}

async function getCount(stateList, campaignListSrc, open, click) {
    let campaignList = JSON.parse(JSON.stringify(campaignListSrc))
    console.log("Computing the list of target recipients")
    console.log(`State List = ${stateList}`)
    console.log(`Campaign List = ${campaignList}`)
    console.log(`Open = ${open}`)
    console.log(`Click = ${click}`)
    let query = [{ "$match": { "IsUsed": "yes" } }]
    let email_count = 0
    let no_campaign_count = 0
    let some_campaign_count = 0
    if (stateList.length !== 0) {
        query.push({ "$match": { "state": { "$in": stateList } } })
    } else {
        return 0
    }
    if (campaignList.length !== 0) {
        if (campaignList.includes(null)) {
            console.log(`Working on a list with at least no campaign recipients`)
            //Running the null query 
            let null_query = [...query]
            null_query.push({ "$match": { "campaign_cart": { "$exists": false } } })
            no_campaign_count = await runQuery(null_query)

            // Checking if anything is left
            let nullIndex = campaignList.findIndex(x => x === null)
            campaignList.splice(nullIndex, 1)
        }
        if (campaignList.length !== 0) {
            query.push({ "$match": { "campaign_cart": { "$exists": true } } })
            if (!campaignList.includes("any"))
                query.push({ "$match": { "campaign_cart.chimpid": { "$in": campaignList } } })
            if (open !== false)
                query.push({ "$match": { "open": { "$exists": true } } })
            if (click !== false)
                query.push({ "$match": { "click_cart": { "$exists": true } } })

            some_campaign_count = await runQuery(query)
        }
        email_count = no_campaign_count + some_campaign_count

    } else {
        email_count = await runQuery(query)
    }
    return email_count
}


export default {
    mailChimpSync,
    getTemplateList,
    getStateList,
    getCampaignList,
    getCount
}